<template>
  <div>
    <com-dialog :visible.sync="visible" :title="type === 'created' ? '创建' : '编辑'" width="40%">
      <template>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="商家名称" prop="businessName">
            <el-input v-model="ruleForm.businessName" placeholder="请输入商家名称"></el-input>
          </el-form-item>
          <el-form-item label="地区" prop="area">
            <com-region :regionId.sync="regionId"></com-region>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input v-model="ruleForm.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="ruleForm.password" placeholder="不设置默认123456"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="证件号" prop="idCard">
            <el-input v-model="ruleForm.idCard" placeholder="请输入证件号"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="address">
            <el-input v-model="ruleForm.address" placeholder="请输入联系地址"></el-input>
          </el-form-item>
          <el-form-item label="合伙人合约" prop="partnerContract">
            <com-upload-file
              accept=".pdf"
              :limit="1"
              :value.sync="ruleForm.partnerContractList"
              @success="handleUploadFile"
              @del-file="handleDelFile"
            ></com-upload-file>
          </el-form-item>
          <el-form-item label="营业资质">
            <com-upload
              :originData="ruleForm.businessLicense"
              @postImage="postImg"
              @deleteImageUrl="delImg"
            ></com-upload>
          </el-form-item>
          <div class="flex justify-end">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-loading="loading"
              >确认</el-button
            >
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </template>
    </com-dialog>
  </div>
</template>

<script>
import utils from 'my-tools-library'
import { addBusinessApi, updateBusinessApi } from '@/api/business'

export default {
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!utils.checkPhone(value)) {
        callback(new Error('请输入正确的手机号码'))
        return
      }
      callback()
    }
    return {
      visible: false,
      type: '',
      loading: false,
      regionId: [],
      ruleForm: {
        businessLicense: '', // 商家资质
        businessName: '',
        address: '',
        password: '',
        account: '',
        name: '',
        phone: '',
        area: '',
        contact: '',
        idCard: '',
        areaCodes: [],
        partnerContract: '',
        type: 2
      },
      rules: {
        businessName: [{ required: true, message: '请输入商家名称', trigger: 'blur' }],
        idCard: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
        area: [{ required: true, message: '请选择地区', trigger: 'blur' }],
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        address: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        partnerContract: [{ required: true, message: '请上传合伙人合约', trigger: 'blur' }],
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    regionId: {
      handler(val) {
        if (val.length) {
          this.ruleForm.area = val.at(-1)
          this.ruleForm.areaCodes = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    open(row) {
      this.type = row.type
      if (this.type === 'created') {
        this.ruleForm = {}
        this.regionId = []
      }
      if (this.type === 'edit') {
        console.log('row :>> ', row)
        this.ruleForm = utils.deepCopy(row.row)
        this.regionId = this.ruleForm.areaCodes ? this.ruleForm.areaCodes : []
        if (this.ruleForm.partnerContract)
          this.ruleForm.partnerContractList = [
            {
              name: '合伙人合约',
              url: this.ruleForm.partnerContract
            }
          ]
      }
      this.visible = true
    },
    close() {
      this.visible = false
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.close()
    },
    postImg(url) {
      this.ruleForm.businessLicense = url
    },
    delImg() {
      this.ruleForm.businessLicense = ''
    },
    handleUploadFile(res) {
      console.log('res :>> ', res)
      this.$set(this.ruleForm, 'partnerContract', res.data.code)
      // this.ruleForm.partnerContract = res.data.code
    },
    handleDelFile() {
      this.ruleForm.partnerContract = ''
    },
    handleCreated() {
      console.log('this.ruleForm :>> ', this.ruleForm)
      if (!this.ruleForm.type) this.ruleForm.type = 2
      if (!this.ruleForm.password) this.ruleForm.password = '123456'
      addBusinessApi(this.ruleForm).then((res) => {
        if (res.status === 200) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.close()
        }
      })
    },
    handleUpdate() {
      if (!this.ruleForm.type) this.ruleForm.type = 2
      console.log('this.ruleForm :>> ', this.ruleForm)
      updateBusinessApi(this.ruleForm).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.close()
      })
    },
    submitForm(formName) {
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type === 'created') {
            this.handleCreated()
            return
          }
          this.handleUpdate()
        }
      })
    }
  }
}
</script>
